<script lang="ts">import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
export let image = '/static/icons/icon-ticketmaster.png';
export let title = "Ticketmaster";
export let email;
export let imgStyleOverride = "";
export let connected = false;
export let onConnect = () => { };
export let sources;
$: linkSource = $sources.find((s) => { var _a; return ((_a = s.spec) === null || _a === void 0 ? void 0 : _a.class) === 'YinzCamSignonServerLinks'; });
let linksRefreshed = false;
$: if (linkSource && !linksRefreshed) {
    setTimeout(() => {
        linkSource.refresh();
    }, 0);
    linksRefreshed = true;
}
</script>

<div class="link-account-card-wrapper">
   <div class="card-row">
       <img src={image} alt="avatar" class="account-logo" style="{imgStyleOverride}"/>
       <div class="title-email-block">
           <span class="title">{title}</span>
           {#if connected && email}
               <span class="connected-email" title={email}>{email}</span>
           {/if}
       </div>
       <button class="btn-connect" class:btn-connect-connected={connected}
           class:btn-connect-disconnected={!connected} on:click={onConnect}>
           Connect{#if connected}ed{/if}
       </button>
   </div>
</div>

<style>.card-row {
  display: flex;
  align-items: center;
  width: 100%;
}

.connected-email {
  font-size: 10px;
  color: #222;
  margin-top: 1px;
  font-weight: 400;
  line-height: 12px;
  max-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  padding-right: 12px;
}

.title-email-block {
  display: flex;
  flex-direction: column;
  justify-content: center;         /* Vertically center as a group */
  align-items: flex-start;
  min-height: 38px;
  margin-top: -2px;
}

.link-account-card-wrapper {
  width: 100%;
  background: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #D8D8D8;
  padding: 12px 16px;
}

.account-logo {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  border: 1px solid #D8D8D8;
  margin-right: 5px;
  flex-shrink: 0;
}

.title {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #000000;
  display: flex;
  align-items: center;
  height: 19px;
}

.btn-connect {
  width: 112px;
  height: 38px;
  border-radius: 8px;
  border: 1px solid var(--alav-s-primary);
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 10px;
  margin-left: auto;
  position: relative;
  cursor:pointer;
  -webkit-user-select:none;
     -moz-user-select:none;
          user-select:none;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition-duration: 0.4s;
  -webkit-transition-duration: 0.4s; /* Safari */
}

.btn-connect:after {
  content: "";
  display: block;
  position: absolute;
  border-radius: 8px;
  left: 0;
  top:0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: all 0.5s;
  box-shadow: 0 0 10px 10px rgb(36, 35, 35);
}

.btn-connect:active:after {
  box-shadow: 0 0 0 0 white;
  position: absolute;
  border-radius: 8px;
  left: 0;
  top:0;
  opacity: 1;
  transition: 0s;
}

.btn-connect-connected {
  color: white;
  background: var(--alav-s-primary);
}

.btn-connect-disconnected {
  color: var(--alav-s-primary);
  background: white;
}</style>